(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["open-chat-button"] && !Shopify.designMode) return;
  try {
    // Opens the Shopify Inbox widget through its public <shopify-chat> element.
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-open-chat]');
    if (!trigger) return;

    const goToFallback = () => {
      if (trigger.dataset.fallback) window.location.href = trigger.dataset.fallback;
    };

    const chat = document.querySelector('shopify-chat');
    if (!chat) return goToFallback();

    if (!customElements.get('shopify-chat')) {
      await Promise.race([
        customElements.whenDefined('shopify-chat'),
        new Promise((resolve) => setTimeout(resolve, 2000)),
      ]);
    }

    try {
      if (typeof chat.show === 'function') {
        chat.show();
      } else if ('open' in chat) {
        chat.open = true;
      } else {
        chat.setAttribute('open', '');
      }
    } catch (_) {
      goToFallback();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
